import React, { useEffect } from 'react';
import Header from '../components/Header';
import PricingSection from '../components/Pricing';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Seo from '@/components/Seo';
import { faqJsonLd } from '@/lib/structured-data';

function Pricing() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="App">
      <Seo
        title="Fiyatlar - Tilki Otomasyon"
        description="Tilki Otomasyon fiyat planları. Aylık ve yıllık ödeme seçenekleri ile restoran otomasyon sisteminizi hemen kurun. Kurulum ücreti yok."
        path="/fiyatlar"
        jsonLd={faqJsonLd}
      />
      <Header />

      <main id="main-content">
        <h1 className="sr-only">Tilki Otomasyon Fiyatları</h1>
        <PricingSection />
      </main>
      <Contact />
      <Footer />
    </div>
  );
}

export default Pricing;
